// extracted by mini-css-extract-plugin
export var banner = "_if-0";
export var closeButton = "_if-2";
export var greenCheckmark = "_if-3";
export var hereLink = "_if-4";
export var titleIcon = "_if-1";